import {Link} from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faChevronLeft} from "@fortawesome/free-solid-svg-icons";
function SignOut() {
    return (
        <div className="px-xxl-5">
            <div className="text-center mb-6">
                <div className="mb-6"><h4 className="text-body-highlight">Come back soon!</h4><p
                    className="text-body-tertiary fs-8-1">Thanks for using Break Through AI Chatbot. <br className="d-lg-none"/>You are now
                    successfully signed out.</p></div>
                <Link className="btn btn-primary w-100" to="/auth/signin">
                    <FontAwesomeIcon className="me-2" icon={faChevronLeft} />
                    Go to sign in page  </Link>
            </div>
        </div>
    )
}

export default SignOut;